import { type ComponentProps } from 'react';

import ArticleContent from '@karehero/llama/components/pages/ArticleContent/ArticleContent';
import WebinarContent from '@karehero/llama/components/pages/WebinarContent/WebinarContent';

import { HELP } from '@/karehero-app/help/Help.content';

type Article = NonNullable<ComponentProps<typeof ArticleContent>['content']>;
type Webinar = NonNullable<ComponentProps<typeof WebinarContent>['content']>;

// Stand-ins for what Sanity sends: the card's own words as the body, so a
// tapped card opens onto the page it would in the app without inventing copy.
const paragraph = (key: string, text: string) => ({
  _key: key,
  _type: 'block' as const,
  style: 'normal',
  markDefs: [],
  children: [{ _key: `${key}-text`, _type: 'span', marks: [], text }],
});

const image = (key: string) => ({ _key: key, _type: 'image' as const });

/** When each webinar runs, for the webinar page. Keyed by the card's id. */
const WHEN: Record<
  string,
  { date: string; startTime: string; endTime: string }
> = {
  'funding-basics': {
    date: '2026-05-26',
    startTime: '18:00',
    endTime: '19:00',
  },
  'attendance-allowance': {
    date: '2026-06-04',
    startTime: '13:00',
    endTime: '14:00',
  },
};

export const helpArticle = (id: string): Article | undefined => {
  const a = HELP.articles.find((x) => x.id === id);
  return (
    a && {
      _id: a.id,
      _createdAt: '2026-03-12T09:00:00Z',
      title: a.title,
      slug: { _type: 'slug', current: a.id },
      slugId: a.id,
      description: a.summary,
      tags: [],
      publisher: 'KareHero',
      content: [paragraph(a.id, a.summary)],
      headerImage: image(`${a.id}-header`),
    }
  );
};

export const helpWebinar = (id: string): Webinar | undefined => {
  const w = HELP.webinars.find((x) => x.id === id);
  return (
    w && {
      _id: w.id,
      title: w.title,
      description: w.summary,
      ...WHEN[w.id],
      speaker: 'KareHero',
      tags: [],
      headerImage: image(`${w.id}-header`),
      callToActionImage: image(`${w.id}-cta`),
      content: [paragraph(w.id, w.summary)],
    }
  );
};
